import React, { useState, useEffect, useRef } from 'react';
import { useTranslations } from './TranslationContext';
import GB from '../../images/flag64/united-kingdoms.png';
import NL from '../../images/flag64/netherlands.png';

const LanguageComponent = () => {
  const { setLanguage, getAllTranslationTexts } = useTranslations();
  const [isOpen, setIsOpen] = useState(false);
  const selectorRef = useRef(null);

  const [currentLanguage, setCurrentLanguage] = useState({ language_code: 'nl', country_code: 'NL', flag: NL });
  const languages = [
    { language_code: 'en', country_code: 'GB', flag: GB },
    { language_code: 'nl', country_code: 'NL', flag: NL },
  ];

  useEffect(() => {
    getAllTranslationTexts(currentLanguage.language_code, currentLanguage.country_code);
  }, [currentLanguage]);

  useEffect(() => {
    if (!isOpen) return;
    function handleClickOutside(event) {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen]);

  function selectLanguage(lang) {
    setCurrentLanguage({ language_code: lang.language_code, country_code: lang.country_code, flag: lang.flag });
    setLanguage({ language_code: lang.language_code, country_code: lang.country_code });
    setIsOpen(false);
  }

  return (
    <div className={`language-selector${isOpen ? ' open' : ''}`} ref={selectorRef}>
      <div className="selected-language" onClick={() => setIsOpen(prev => !prev)}>
        <img className="flag-icon" src={currentLanguage.flag} alt={currentLanguage.language_code} />
        <span className="lang-code">{currentLanguage.language_code.toUpperCase()}</span>
        <span className="lang-chevron">▾</span>
      </div>
      <ul className={`language-dropdown${isOpen ? ' visible' : ''}`}>
        {languages.map((lang, index) =>
          lang.language_code !== currentLanguage.language_code ? (
            <li key={index}>
              <div className="flag-dropdown-item" onClick={() => selectLanguage(lang)}>
                <img className="flag-icon" src={lang.flag} alt={lang.language_code} />
                <span className="lang-code">{lang.language_code.toUpperCase()}</span>
              </div>
            </li>
          ) : null
        )}
      </ul>
    </div>
  );
};

export default LanguageComponent;
